import type { Client, OperationContext } from "@opensea/graphql"
import { graphql, prefetch, useQuery } from "@opensea/graphql"

const CollectionAttributesQuery = graphql(`
  query CollectionAttributesQuery(
    $slug: String!
    $limit: Int!
    $cursor: String
  ) {
    collectionBySlug(slug: $slug) {
      __typename
      ... on Collection {
        id
        attributes(limit: $limit, cursor: $cursor) {
          items {
            traitType
            values {
              __typename
              value
            }
          }
          nextPageCursor
        }
      }
    }
  }
`)

const PAGE_SIZE = 100

export function useCollectionAttributes(
  collectionSlug: string,
  context?: Partial<OperationContext>,
) {
  const [{ data, error, fetching }] = useQuery(
    {
      query: CollectionAttributesQuery,
      variables: { slug: collectionSlug, limit: PAGE_SIZE },
      context,
    },
    { throwOnError: false },
  )

  return {
    items:
      data?.collectionBySlug?.__typename === "Collection"
        ? data.collectionBySlug.attributes.items
        : [],
    error,
    fetching,
  }
}

export function prefetchCollectionAttributes(
  collectionSlug: string,
  client: Client,
) {
  return prefetch(client, CollectionAttributesQuery, {
    slug: collectionSlug,
    limit: PAGE_SIZE,
  })
}
